module.exports = __webpack_public_path__ + "img/mirror12.76e2cb6b.jpg";